import { render } from "./Access.vue?vue&type=template&id=688bcaa0&scoped=true"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"

import "./Access.vue?vue&type=style&index=0&id=688bcaa0&lang=css"
import "./Access.vue?vue&type=style&index=1&id=688bcaa0&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688bcaa0"]])

export default __exports__